export default __webpack_public_path__ + "static/media/haj6.ec8530a6.jpg";